// extracted by mini-css-extract-plugin
export default {"tabGroup":"_6KffpqsXc2Xr7eLrtew7TG"};